import {OpportunityContract} from '../opportunity/opportunity-contract.model';
import {AssetPackageDto} from '../asset-package/asset-package.model';
import {Opportunity} from "../opportunity/opportunity.model";

export class AuditAssetMove {
  assetId: number;
  equipId: number;
  destinationType: string;
  pullReason: string;
  pullReasonExplanation: string;
  additionalComments: string;
  confirmedOn: Date;
  confirmedBy: string;
  selectedOpportunity: OpportunityContract;
  selectedContract: OpportunityContract;
  currentAssetControlGroup: AssetPackageDto;
  targetAssetControlGroup: AssetPackageDto;
  currentOpportunity: Opportunity;
  oldOwnerCode: string;
  newOwnerCode: string;
  oldScheduleNumber: number;
  newScheduleNumber: number;
  oldContractId: number;
  newContractId: number;
  oldOpportunityId: number;
  newOpportunityId: number;
  oldAuctionEventId: number;
  newAuctionEventId: number;
  oldSaleType: string;
  newSaleType: string;
  retainSaleInfo: string;
  contractMoveType: string;
}
